// src/screens/Home.js
export function HomeScreen(container, state, actions) {
  container.innerHTML = `
    <div class="screen">
      <div class="top-bar">
        <div class="logo">
          <div class="logo-sq"><i class="ti ti-building-factory-2" aria-hidden="true"></i></div>
          <div><div class="logo-name">CONCREPRO</div><span class="logo-sub">ACI · ICRI · EN 1504</span></div>
        </div>
        <div class="sponsor-badge"><i class="ti ti-star" aria-hidden="true" style="font-size:9px"></i> Sika</div>
      </div>
      <div class="screen-body" style="display:flex;flex-direction:column;align-items:center;padding-top:24px">
        <div style="text-align:center;padding:16px 0 28px;max-width:320px;width:100%">
          <div class="card-label" style="color:var(--amber);display:flex;justify-content:center;margin-bottom:12px">
            Diagnóstico de patología del concreto
          </div>
          <h1 style="font-size:22px;font-weight:500;line-height:1.2;margin:0 0 10px">
            Foto → diagnóstico<br><span style="color:var(--amber)">normado</span> en segundos
          </h1>
          <p style="font-size:13px;color:var(--dim);margin:0 0 20px;line-height:1.6">
            9 patologías. Reporte PDF + borrador LinkedIn automático. Sin registro.
          </p>
          <button id="btn-diagnose" class="btn-primary" style="max-width:260px;margin:0 auto">
            <i class="ti ti-camera" aria-hidden="true"></i> Diagnosticar ahora
          </button>
        </div>
        <div class="grid-2" style="max-width:320px;width:100%">
          ${[
            ['ti-bolt',             'Instantáneo',  '< 15 segundos'],
            ['ti-file-description', 'PDF normado',  'ACI / ICRI / EN 1504'],
            ['ti-brand-linkedin',   'LinkedIn',     'Borrador auto-generado'],
            ['ti-shield-check',     'Privacidad',   'Imagen no almacenada'],
          ].map(([icon, label, desc]) => `
            <div class="card" style="margin-bottom:0">
              <i class="ti ${icon}" style="font-size:18px;color:var(--amber)" aria-hidden="true"></i>
              <div style="font-size:13px;font-weight:500;margin:6px 0 2px">${label}</div>
              <div style="font-size:12px;color:var(--dim)">${desc}</div>
            </div>`).join('')}
        </div>
        <div style="display:flex;flex-wrap:wrap;gap:5px;margin-top:16px;justify-content:center;max-width:320px">
          ${['ACI 224.1R','ACI 222R','ICRI 210.1R','ACI 546R','EN 1504-9','ACI 302.1R']
            .map(n => `<span class="sponsor-badge" style="font-size:10px">${n}</span>`).join('')}
        </div>
      </div>
    </div>`;

  container.querySelector('#btn-diagnose').onclick = () => actions.navigate('capture');
}
